import { render } from "./Polizagarantia.vue?vue&type=template&id=799e4775&scoped=true"
import script from "./Polizagarantia.vue?vue&type=script&lang=js"
export * from "./Polizagarantia.vue?vue&type=script&lang=js"

import "./Polizagarantia.vue?vue&type=style&index=0&id=799e4775&scoped=true&lang=css"

import exportComponent from "D:\\Users\\felipecedillo\\Documents\\GitHub\\marbel-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-799e4775"]])

export default __exports__